import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Navigate,
  Route,
} from "react-router-dom";
import Login from "./authentification/Login/login";
import Signup from "./authentification/signup/Signup";
import Dashboard from "./dashboard/dashboard";
import DashboardAdmin from "./dashboardAdmin/dashboardAdmin";
import DashboardAdminComercial from "./dashboardAdmin_Comercial/dashboardAdmin_Comercial";
import CompanyDescription from "./authentification/CompanyDescription"; 
import PrivateRoute from "./authentification/PrivateRoute";
import { PopupProvider } from "./PopupContext";
import { ToastContainer } from "react-toastify";
import CategoryProducts from "./MarketPlace/CategoryProducts/CategoryProducts";
import ProductDetail from "./MarketPlace/ProductDetail/ProductDetail";
import LudoChampionsLeague from "./Ludo Champions League/ludoChampionsLeague";
import News from "./authentification/NavbarLog/News";
function App() {
  return (
    <PopupProvider>
      <Router>
        <div className="App">
          <div
            className="App-background"
            style={{
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "100vh",
              width: "100vw",
            }}
          >
            <Routes>
              <Route path="/" element={<Navigate to="/login" />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/company-description" element={<CompanyDescription />} /> {/* Nouvelle route */}
              <Route path="/News" element={<News />} />
              <Route 
                path="/dashboard" 
                element={<PrivateRoute element={<Dashboard />} requiredRole={null} />} 
              />
              <Route 
                path="/dashboardAdmin" 
                element={<PrivateRoute element={<DashboardAdmin />} requiredRole="admin" />} 
              />
               <Route 
                path="/dashboardCommercial" 
                element={<PrivateRoute element={<DashboardAdminComercial />} requiredRole="commercial_admin" />} 
              />
           {/* <Route path="/category" element={<Category />} /> */}
           <Route path="/category" element={<CategoryProducts />} />
           <Route path="/Ludo-Champions-League" element={<LudoChampionsLeague/>} />
           <Route path="/product/:id" element={<ProductDetail />} />
            </Routes>
            <ToastContainer
              position="top-right"
              autoClose={2000}
              hideProgressBar={false}
            />
          </div>
        </div>
      </Router>
    </PopupProvider>
  );
}

export default App;